import styled from 'styled-components';

export const StyledCheckoutBar = styled.div`
  background-color: ${props => props.theme.colors.background.base};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: ${props => props.theme.spacing(3, 4)};
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: 100%;
`;

export const BackColumn = styled.div`
  margin: auto 0 0 0;
`;

export const ContinueColumn = styled.div`
  width: 100%;
`;

export const StyledAmountInfo = styled.div`
  ${props => props.theme.typography.heading6};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-bottom: ${props => props.theme.spacing(2)};
`;

export const PriceBeforeDiscount = styled.p`
  color: ${props => props.theme.colors.text.secondary};
  font-weight: normal;
  text-decoration-line: line-through;
`;

export const Price = styled.p`
  margin-left: ${props => props.theme.spacing(1)};
`;
